import React, { Component } from 'react';
import { Image } from 'react-bootstrap';
import '../content/css/NotAllowedPage.css';

var logo = require("../content/images/legly_logo_color.svg");

export default class NotFoundPage extends Component {
    render() {
        return (
            <div>
                <h1>404 Error</h1>
                <h1>Page Not Found</h1>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/NotFoundPage.js